import React from 'react';
// import useNebula from 'hooks/useNebula';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Butter from '../Charts/Butter';
import TranslationTxt from '../../survey2022/TranslationTxt/TranslationTxt';

import useStyles from './styles';

// import AppContext from '../AppContext';

const ButterflySection = ({ header, text }) => {
  const classes = useStyles();

  // const nebula = useNebula();
  //   const { qlikApp } = useContext(AppContext);
  // const vizRef = useRef();

  // useEffect(async () => {
  //   if (!nebula) return;
  //   vizRef.current = await nebula.render({
  //     element: vizRef.current,
  //     id: '62305d64-0b32-4f42-8a3d-3f6b9afe18fe',
  //   });
  // }, [nebula]);

  return (
    <div className="section" style={{ marginBottom: 50, marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
      </Typography>
      {/* <div className={classes.butterflyViz} ref={vizRef} style={{ height: 650 }} />
      <br />
      <br /> */}
      <Butter />
    </div>
  );
};

ButterflySection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

ButterflySection.defaultProps = {
  header: '',
  text: '',
};

export default ButterflySection;
